export interface ResetEmail {
  resetMailSent: boolean;
}

export const RESET_INITIAL_STATE: ResetEmail = {
  resetMailSent: false,
};
